export default "__VITE_ASSET__Dq2d0UIR__"